import { getQueryParams } from 'utils/common';

// export const getMediwireApiUrl = props => `https://stg.mediawire.in/mediawireHomePage/getHPStory?\
// hostid=83&platform=3&secid=2345654&sltno=${props.sltno}&geocl=${props.city}\
// &geostate=${props.region_code}&geolocation=${props.CountryCode}&geocontinent=${
//   props.Continent
// }&appPlatform=${props.appPlatform}`;

export const getMediwireApiUrl = props =>
  __PROD__
    ? `https://api.mediawire.in/mediawire-api/mediawireHomePage/v2/getHPStory?\
hostid=83&platform=3&secid=${props.secid}&sltno=${props.sltno}&geocl=${
        props.city
      }&geostate=${props.region_code}&geolocation=${
        props.CountryCode
      }&geocontinent=${props.Continent}&app_platform=${props.appPlatform}`
    : `https://stg.mediawire.in/mediawire-api/mediawireHomePage/v2/getHPStory?\
hostid=83&platform=1&secid=${props.secid}&sltno=${props.sltno}&geocl=${
        props.city
      }&geostate=${props.region_code}&geolocation=${
        props.CountryCode
      }&geocontinent=${props.Continent}&app_platform=${props.appPlatform}`;

export const createGA = ({ item, index, isWapView }) => {
  const { wu = '' } = item;
  if (isWapView === false) {
    return `TopSection-Actions#TopClick-Grid1/${index + 1}${wu}`;
  }
  return '';
};

export const getAppPlatform = isWapView => {
  if (isWapView === true) {
    return 'mweb';
  } else if (isWapView === false) {
    return 'web';
  }
  return '';
};

/**
 * Timeout value in milliseconds for mediawire api
 */
export const timedoutVal = 5000;

export const getSlotNumber = isWapView => {
  if (isWapView === true) {
    return '11';
  }
  return '13';
};

export const getSecId = isWapView => {
  if (isWapView === true) {
    return '51396865';
  }
  return '-2128958273';
};

export const isEmpty = str => !str || str.length === 0;

export const getGeoInfo = () => {
  if (typeof window === 'undefined') {
    return {};
  }
  const CountryCode = getQueryParams('CountryCode');
  const Continent = getQueryParams('Continent');
  const city = getQueryParams('city');
  const region_code = getQueryParams('region_code');
  if (
    !isEmpty(CountryCode) &&
    !isEmpty(Continent) &&
    !isEmpty(city) &&
    !isEmpty(region_code)
  ) {
    return {
      CountryCode,
      city,
      Continent,
      region_code,
    };
  }
  return {
    ...window.geoinfo,
  };
};
